module.exports = __webpack_public_path__ + "static/media/转接模块B2.d51fa93f.png";